@if (links.length !== 0) {
  <hr>
  <div class="social-media-footer">
    @for (link of links; track link.title) {
      <div class="social-media-footer__item">
        @if (link.nodeType === 'label') {
          <p class="social-media-footer__title" [ngClass]="link.cssClass">{{ link.title }}</p>
          <div class="social-media-footer__content">
            @for (child of link.children; track child.title) {
              @if (child.isActive) {
                <a
                   [ngClass]="!isIcon(child.cssClass) ? child.cssClass : 'circle'"
                   [href]="child.url"
                   [target]="'_blank'">
                  <span [ngClass]="isIcon(child.cssClass) ? child.cssClass : ''"></span>
                  {{ (isIcon(child.cssClass)) ? '' : child.title }}</a>
              }
            }
           </div>
        }
      </div>
    }
  </div>
}
